import { Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 100%;
  height: fit-content;
  flex-shrink: 0;
  border-radius: 10px 10px 10px 10px;
  background: #f4f4f4;
  cursor: pointer;
`;

export const Header = styled(Box)<{ rsvp?: "N" | "A" }>`
  width: 100%;
  height: 27px;
  flex-shrink: 0;
  border-radius: 10px 10px 0px 0px;
  background-color: ${(props) => (props.rsvp === "A" ? "#f4f4f4" : "#CBD5E0")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled(Box)<{ rsvp?: "N" | "A" }>`
  width: 100%;
  height: 99px;
  display: flex;
  flex-direction: column;
  padding: 5px 18px;
  border-radius: 0px 0px 10px 10px;
  background-color: ${(props) => (props.rsvp === "A" ? "#fff" : "#EDF2F7")};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;

export const Info = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftSection = styled(Box)`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RightSection = styled(Box)`
  width: 50%;
  display: flex;
  word-break: break-all; /* Use break-all to force the text to wrap even if it's longer than the container */
  flex-direction: column;
  align-items: center;
`;

export const DateWrapper = styled(Box)`
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Section = styled(Box)`
  background: #e2e8f0;
  padding: 0.5px;
  margin: 0 10px;
`;

export const Wrapper = styled(Box)`
  display: flex;
`;

export const Footer = styled(Box)`
  padding-top: 12px;
`;

export const FooterWrapper = styled(Box)`
  display: flex;
  padding-top: 4px;
  justify-content: start;
  align-items: center;
  gap: 8px;
`;

export const GameCardTypography = styled(Typography)`
  color: #1d1d1d;
  font-family: "NotoSans-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const LocationTypography = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
